module.exports = __webpack_public_path__ + "2dbf41201cf90bc5f9192cb5a33f6f49.fbx";